/**
 * @returns {import("~/config/useGetRichtTextValues").RichTextValuesLocales}
 */
export const fseIntRichTextValues = {
  'en-US': {
    contactEmail: 'careers@fresenius.com',
    homeUrl: '/',
    jobSearchUrl: '/job-search',
    disclaimerUrl: '',
    healthgroupUrl: 'https://careers.fresenius.com/#healthcaregroup',
    searchUrl: 'https://careers.fresenius.com/#search',
    privacyPolicyUrl: '/data-protection',
    dataProtectionUrl: '/en-US/data-protection',
  },
};
